var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "other_incomes" },
    [
      _c("form-section", {
        attrs: {
          sectionTitle: _vm.$t("applications.other-income"),
          wideFirstCol: ""
        },
        scopedSlots: _vm._u([
          {
            key: "col-1",
            fn: function() {
              return [
                _vm._l(_vm.entitiesData, function(income) {
                  return _c(
                    "div",
                    { key: income.id },
                    [
                      _c("control-tool-bar", {
                        attrs: {
                          id: income.id,
                          title: _vm.$_.get(income, "required", false)
                            ? _vm.$t("applications.income")
                            : _vm.$t("applications.other-income"),
                          type: _vm.$_.get(income, "required", false)
                            ? "current"
                            : "",
                          removeable: income.removeable
                        },
                        on: {
                          remove: function($event) {
                            return _vm.removeEntity(income.id)
                          }
                        }
                      }),
                      _c("applicant-other-income", {
                        attrs: {
                          modelData: income,
                          required: _vm.$_.get(income, "required", false)
                        },
                        on: {
                          update: function($event) {
                            return _vm.update(income.id, "root", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm.entitiesData.length < _vm.MAX_INCOMES
                  ? _c(
                      "v-layout",
                      { staticClass: "mt-1" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mb-2",
                            attrs: { color: "secondary", dark: "" },
                            on: {
                              click: function($event) {
                                return _vm.createEntity("other_income")
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("add_circle")
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("applications.add-other-income")) +
                                " "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }